import { useNavigate, useLocation } from 'react-router-dom';
import { Box } from '@mui/material';
import { useMemo } from 'react';

import { Tabs } from 'app/shared-components/structure';
import { useNavigationHeader } from 'app/hooks';

const tabs = [
  {
    label: 'Listed services',
    value: 'master-services',
    path: '/master-services',
  },
  {
    label: 'Categories',
    value: 'categories',
    path: '/master-services/categories',
  },
];

export default function ServiceCatalogueLayout({ children }) {
  const navigate = useNavigate();
  const location = useLocation();

  useNavigationHeader({ title: 'Master services' });

  const selectedTab = useMemo(
    () => tabs.find((tab) => location.pathname.endsWith(tab.value))?.value ?? tabs[0].value,
    [location.pathname]
  );

  function handleTabChange(event, newValue) {
    const newPath = tabs.find((tab) => tab.value === newValue)?.path;
    if (newPath) navigate(newPath, { replace: true });
  }

  return (
    <Box className="grow flex flex-col px-20 py-16 gap-16 bg-white overflow-hidden">
      <Tabs tabs={tabs} selectedTab={selectedTab} handleChange={handleTabChange} />
      {children}
    </Box>
  );
}
